import Sortable from 'sortablejs';
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['list', 'item']

  connect() {
    Sortable.create(this.listTarget, {
      handle: '.sortable-item .handle',
      onUpdate: (event) => {
        const newTargets = this.listTarget.querySelectorAll("[data-target='sortable.item']");
        const ids = [...newTargets].map(item => item.dataset.id);

        fetch(this.data.get('url'), {
          method: 'POST',
          mode: 'same-origin',
          body: JSON.stringify({ sorted_ids: ids }),
          headers: {
            'Content-Type': 'application/json',
          },
        });
      },
    });
  }
}
